<template>
  <basic-dialog :show="show" @close="$emit('close')" max-width="80%">
    <template v-slot:title>Itinerary Comp</template>
    <v-row>
      <v-col sm="4">
        <v-select
          label="Supplier"
          :items="selectableSuppliers"
          item-text="name"
          item-value="id"
          v-model="selectedSupplierId"
          :outlined="outlinedInputs"
        ></v-select>
      </v-col>
      <v-col>
        <v-text-field
          type="number"
          label="Pax From"
          v-model.number="paxFrom"
          :outlined="outlinedInputs"
        />
      </v-col>
      <v-col>
        <v-text-field
          type="number"
          label="Pax To"
          v-model.number="paxTo"
          :outlined="outlinedInputs"
        />
      </v-col>
      <v-col>
        <v-text-field
          type="number"
          :label="freeLabel"
          v-model.number="free"
          :outlined="outlinedInputs"
        />
      </v-col>
      <v-col>
        <v-text-field
          type="number"
          :label="passLabel"
          v-model.number="pass"
          :outlined="outlinedInputs"
        />
      </v-col>
      <v-col sm="4">
        <v-select
          label="Comp Service"
          :items="selectableServices"
          item-text="name"
          item-value="id"
          v-model="selectedServiceId"
          :outlined="outlinedInputs"
        ></v-select>
      </v-col>
    </v-row>
    <template v-slot:actions>
      <v-btn color="primary" :disabled="!isValid" @click="onSave">Save</v-btn>
    </template>
    <code v-if="debug">{{ selectedService }}</code>
  </basic-dialog>
</template>

<script>
import BasicDialog from "../../../shared/BasicDialog.vue";
const randomize = require("randomatic");
export default {
  components: { BasicDialog },
  name: "itinerary-comp-dialog",

  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: Object,
      default: () => null,
    },
    suppliers: {
      type: Array,
      default: () => [],
    },
    services: {
      type: Array,
      default: () => [],
    },
    itiItems: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      debug: false,
      paxFrom: this.value ? this.value.paxFrom : 1,
      paxTo: this.value ? this.value.paxTo : 10,
      free: this.value ? this.value.free : 0,
      pass: this.value ? this.value.pass : 0,
      selectedSupplierId: this.value ? this.value.supplier.id : "",
      selectedServiceId: this.value ? this.value.service.id : "",
    };
  },

  watch: {
    value(newVal) {
      if (newVal) {
        this.selectedSupplierId = newVal.supplier.id;
        this.selectedServiceId = newVal.service.id;
        this.pass = newVal.pass;
        this.free = newVal.free;
        this.paxFrom = newVal.paxFrom;
        this.paxTo = newVal.paxTo;
      }
    },
  },

  computed: {
    selectedService() {
      return this.itiItems.find(
        (item) => item.serviceId == this.selectedServiceId
      );
    },
    selectedServiceItemBased() {
      return this.selectedService && this.selectedService.pricing.itemBased;
    },
    freeLabel() {
      return this.selectedServiceItemBased ? "Comp Units" : "Comp Pax";
    },
    passLabel() {
      return this.selectedServiceItemBased
        ? "Pass Comp Units"
        : "Pass Comp Pax";
    },
    selectableSuppliers() {
      return this.suppliers;
    },
    selectableServices() {
      const items =
        this.selectedSupplierId != ""
          ? this.services.filter((s) => s.supplierId == this.selectedSupplierId)
          : [...this.services];
      if (
        this.value &&
        items.map((i) => i.id).indexOf(this.value.service.id) == -1
      ) {
        items.push({
          name: this.value.service.name,
          id: this.value.service.id,
        });
      }
      return items;
    },
    isValid() {
      return this.selectedSupplierId != "" && this.selectedServiceId != "";
    },
    isNew() {
      return !this.value;
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
  },

  methods: {
    onSave() {
      const selectedSupplier = this.selectableSuppliers.find(
        (s) => s.id == this.selectedSupplierId
      );
      const selectedService = this.selectableServices.find(
        (s) => s.id == this.selectedServiceId
      );
      const item = {
        id: this.value ? this.value.id : randomize("Aa0", 32),
        pass: this.pass,
        free: this.free,
        paxFrom: this.paxFrom,
        paxTo: this.paxTo,
        supplierCompId: this.value ? this.value.supplierCompId : "",
        supplierId: this.selectedSupplierId,
        serviceId: this.selectedServiceId,
        service: {
          id: this.selectedServiceId,
          name: selectedService ? selectedService.name : "",
        },
        supplier: {
          id: this.selectedSupplierId,
          name: selectedSupplier ? selectedSupplier.name : "",
        },
      };
      this.$emit("input", item);
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/builder/tools/ItineraryCompDialog.vue